import { defineMessages } from 'react-intl';

export default defineMessages({
  civilRequestLabelTitle: {
    id: 'legal_proceeding_page.civil_request',
  },
  judgementAddLabelTitle: {
    id: 'court_manager_legal_proceedings_page.judgement_add_tab.title',
  },
  expertReportLabelTitle: {
    id: 'court_manager_legal_proceedings_page.expert_report_tab.title',
  },
  judgementOnMeritsLabelTitle: {
    id: 'legal_proceeding_page.judgement_on_merits_tab_title',
  },
  appealAddLabelTitle: {
    id: 'legal_proceeding_page.judgement_add_appeal',
  },
  expertReportAppealLabelTitle: {
    id: 'legal_proceeding_page.expert_report_appeal',
  },
  appealOnMeritsLabelTitle: {
    id: 'legal_proceeding_page.judgement_on_merits_appeal',
  },
});
